export type Env =
  | 'local'
  | 'ddev'
  | 'stg'
  | 'stg-fex'
  | 'stg-fedm'
  | 'prod'
  | 'prod-fedm'
  | 'unknown';

export type EnvType = 'dev' | 'staging' | 'prod' | 'unknown';

function inferEnvFromHostname(hostname: string): Env {
  if (hostname === 'localhost') {
    return 'local';
  }

  if (hostname.endsWith('.dev.internal.atlassian.com') || hostname.endsWith('.dev.atlassian.com')) {
    return 'ddev';
  }

  if (hostname.endsWith('.stg.internal.atlassian.com') || hostname.endsWith('.stg.atlassian.com')) {
    return 'stg';
  }

  if (hostname.endsWith('.atlassian-fex.com')) {
    return 'stg-fex';
  }

  if (hostname.endsWith('.stg.atlassian-us-gov-mod.com')) {
    return 'stg-fedm';
  }

  if (hostname.endsWith('.atlassian-us-gov-mod.com')) {
    return 'prod-fedm';
  }

  if (hostname.endsWith('.atlassian.com')) {
    return 'prod';
  }

  return 'unknown';
}

export const currentEnv: Env = inferEnvFromHostname(window.location.hostname);

const envTypes: Record<Env, EnvType> = {
  local: 'dev',
  ddev: 'dev',
  stg: 'staging',
  'stg-fex': 'staging',
  'stg-fedm': 'staging',
  prod: 'prod',
  'prod-fedm': 'prod',
  unknown: 'unknown',
};
export const currentEnvType: EnvType = envTypes[currentEnv];

const idacOrigins: Record<Env, string> = {
  local: 'http://localhost:8080', // idproxy local
  ddev: 'https://id-domain.dev.internal.atlassian.com',
  stg: 'https://id.stg.internal.atlassian.com',
  'stg-fex': 'https://id.atlassian-fex.com',
  'stg-fedm': 'https://id.stg.atlassian-us-gov-mod.com',
  prod: 'https://id.atlassian.com',
  'prod-fedm': 'https://id.atlassian-us-gov-mod.com',
  unknown: 'https://id.atlassian.com', // safe default
};

export const idacOrigin = idacOrigins[currentEnv];

export type Perimeter = 'commercial' | 'fedramp-moderate';

const perimeters: Record<Env, Perimeter> = {
  local: 'commercial',
  ddev: 'commercial',
  stg: 'commercial',
  'stg-fex': 'commercial', // This is what Micros will inject, lets just use that for now.
  'stg-fedm': 'fedramp-moderate',
  prod: 'commercial',
  'prod-fedm': 'fedramp-moderate',
  unknown: 'commercial',
};

export const currentPerimeter = perimeters[currentEnv];
export const getCurrentPerimeter = () => perimeters[currentEnv];
export const isFedM = () => getCurrentPerimeter() === 'fedramp-moderate';
